// Base
import Link from 'next/link'
import { UrlObject } from 'url'

interface NextLinkProps {
  href: UrlObject | string
  children: React.ReactNode
}

const NextLink = ({ href, children }: NextLinkProps) => {
  return <Link href={href}>{children}</Link>
}
export default NextLink
